
import React from 'react';
import { Phone, Palette, MessageSquare, Rocket } from 'lucide-react';
import ScrollReveal from '../ui/ScrollReveal';

const ProcessSection = () => {
  const steps = [
    {
      number: "01",
      icon: <Phone className="h-8 w-8 text-white" />,
      title: "Discovery Call & Strategy",
      description: "We learn about your business goals, target audience, and design preferences to create the perfect strategy."
    },
    {
      number: "02", 
      icon: <Palette className="h-8 w-8 text-white" />,
      title: "Custom Design & Copywriting",
      description: "Our team crafts a unique design and writes compelling copy that converts visitors into customers."
    },
    {
      number: "03",
      icon: <MessageSquare className="h-8 w-8 text-white" />,
      title: "Build & Feedback",
      description: "We build your site and send you a unique link where you can click anywhere to comment and request changes — no tech skills needed."
    },
    {
      number: "04",
      icon: <Rocket className="h-8 w-8 text-white" />,
      title: "Launch & Maintain",
      description: "We launch your website and provide ongoing maintenance, hosting, and support so you can focus on your business."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 to-black text-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-semibold mb-4">
              Our Simple 4-Step Process
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={150}>
            <p className="text-lg text-white/80 max-w-3xl mx-auto">
              From concept to launch, we make the entire process seamless and stress-free for you.
            </p>
          </ScrollReveal>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <ScrollReveal key={index} delay={200 * index}>
              <div className="relative">
                <div className="flex items-start space-x-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center relative">
                      {step.icon}
                      <div className="absolute -bottom-2 -right-2 bg-white text-gray-900 rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold">
                        {step.number}
                      </div>
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold mb-3">
                      {step.title}
                    </h3>
                    <p className="text-white/80 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
                
                {/* Connecting line for larger screens */}
                {index < steps.length - 1 && index % 2 === 0 && (
                  <div className="hidden lg:block absolute top-20 left-8 w-px h-32 bg-gradient-to-b from-white/20 to-transparent"></div>
                )}
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
